import React from 'react';
import { useNavigate } from 'react-router-dom';

const LoggedAreaCTA = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <section className="py-16 bg-[#FDFCF8] border-b border-gray-100">
      <div className="container mx-auto px-4 text-center">
        <div className="inline-flex flex-col sm:flex-row items-center gap-6 p-8 rounded-[3rem] bg-white shadow-sm border border-gray-100">
           <span className="text-xl font-bold text-gray-500 italic">🔐 Já tem conta?</span>
           <button 
            onClick={handleLoginClick}
            className="bg-black text-white px-10 py-4 rounded-full font-display text-lg hover:bg-gray-800 transition-all active:scale-95 flex items-center gap-2"
           >
             👉 Entrar na área logada
           </button>
        </div>
      </div>
    </section>
  );
};

export default LoggedAreaCTA;

